export const trimSlashes = (value: string) => value.replace(/^\/|\/$/g, '');
